/**
 * Option matching for `Combobox`, kept out of the component so it can be
 * tested without a DOM.
 *
 * Two rules, both of which existed only implicitly before:
 *  - an option matches on its visible label OR any of its `searchAliases`;
 *  - the caller's `normalize` (Arabic diacritics, alef/ya/ta-marbuta folding)
 *    applies to aliases too, not just the rendered name.
 */
export type MatchableOption = {
  label: string;
  searchAliases?: string[];
};

export function optionMatchesQuery(
  option: MatchableOption,
  query: string,
  normalize?: (value: string) => string,
): boolean {
  const lower = query.toLowerCase();
  const normalizedQuery = normalize ? normalize(query) : null;
  const matches = (text: string): boolean =>
    text.toLowerCase().includes(lower) ||
    (normalizedQuery !== null &&
      normalize !== undefined &&
      normalize(text).includes(normalizedQuery));
  return matches(option.label) || (option.searchAliases ?? []).some(matches);
}
